export const REQUEST_CREATE_METRIC = "request_create_metric" 
export const CREATE_METRIC_SUCCES = "create_metric_succes"
export const CREATE_METRIC_FAILURE = "create_metric_failure"
export const CLEAR_CREATE_METRICS = "clear_create_metrics"
